<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">

            <div v-if="errorMessage.length > 0" id="errorNotification">
              <base-alert v-for="msg in errorMessage" type="danger" v-if="msg!=null && msg!=''">
                <span class="alert-inner--text">{{msg}}</span>
              </base-alert>
            </div>

            <div v-if="successMessage != null">
                <base-alert type="primary" dismissible>
                    <span class="alert-inner--text"> {{successMessage}}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                       <span aria-hidden="true">&times;</span>
                    </button>
                </base-alert>
            </div>

            <div class="card bg-secondary shadow border-0">
                <!-- <div class="card-header bg-transparent pb-5">
                    <div class="text-muted text-center mt-2 mb-3">
                        <small>Sign up with</small>
                    </div>
                    <div class="btn-wrapper text-center">
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a>
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                            <span class="btn-inner--text">Google</span>
                        </a>
                    </div>
                </div> -->
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <h2>Password Change</h2>
                    </div>
                    <form role="form">

                        <small>
                            Please input the email tagged to your account.
                        </small> <br><br>

                        <!--
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Account Name"
                                    addon-left-icon="ni ni-building"
                                    v-model="model.account_name">
                        </base-input>
                        -->

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Email"
                                    addon-left-icon="ni ni-email-83"
                                    v-model="model.email">
                        </base-input>

                        <!--
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Temporary Code"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="model.temporary_code">
                        </base-input>
                        -->
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="New Password"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="model.new_password">
                        </base-input>
                        
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="New Password Confirmation"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="model.new_password_confirmation">
                        </base-input>

                        <b-form-text v-if="userPasswordFormatStrict"  id="password-help" v-html="passwordValidationLabel"></b-form-text>
                        <b-form-text  v-else  id="password-help">Limited to 6-15 alphanumeric characters only</b-form-text>

                        <div class="text-center">
                            <base-button @click.prevent="passwordChange" type="danger" class="my-4">Change Password</base-button><br>
                            <a @click.prevent="backTologin" class="text-dark"><small>Login to your account</small></a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js'
import { mapState, mapActions} from 'vuex'
import axios from "axios";
import ValidateField from '../components/validateFormUtils'
var navigate, component_x;

  export default {
    mounted: function(){
        navigate = this.$router;
        component_x = this;
        this.getAccountSettings()
    },
    computed: {
        ...mapState(['loggedIn', 'endPoint', 'userEmail']),
    },
    name: 'register',
    data() {
      return {
        model: {
          account_name: '',
          email: '',
          temporary_code: '',
          new_password: '',
          new_password_confirmation: ''
        },
        errorMessage: [],
        successMessage: null,
        userPasswordFormatStrict: false,
        passwordValidationLabel:"",
        passwordformatValidation:{
            minPasswordLength:6,
            passwordReqOneUppercase:false,
            passwordReqOneLowercase:false,
            passwordReqOneNumber:false,
            passwordReqOneSpecialChar:false,
            passExpDuration:null
        },
      }
    },
    watch:{
      'model.new_password': function(){
        if(this.userPasswordFormatStrict){
          this.passwordValidationLabel = ""
          if (this.model.new_password.length < this.passwordformatValidation.minPasswordLength) {
            this.passwordValidationLabel += `Your password needs a minimum of ${this.passwordformatValidation.minPasswordLength} characters. <br>`;
          }
          if (this.passwordformatValidation.passwordReqOneLowercase && this.model.new_password.search(/[a-z]/) == -1) {
            this.passwordValidationLabel += "Your password needs at least one lower case letter. <br>";
          }
          if (this.passwordformatValidation.passwordReqOneUppercase && this.model.new_password.search(/[A-Z]/) == -1) {
            this.passwordValidationLabel += "Your password needs at least one upper case letter. <br>";
          }
          if (this.passwordformatValidation.passwordReqOneNumber && this.model.new_password.search (/[0-9]/) == -1) {
            this.passwordValidationLabel += "Your password needs a number.<br>";
          }
          if (this.passwordformatValidation.passwordReqOneSpecialChar && this.model.new_password.search (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) == -1){
            this.passwordValidationLabel += "Your password needs at least one special character.<br>";
          }
        }
      }
    },
    methods: {
      ...mapActions(['updateLoggedInStatus', 'updateUserEmail']),
      backTologin(){
          navigate.push('/');
      },
      validation() {
        this.errorMessage = [];

        // Check if Account name is blank
        // if (!this.model.account_name.trim()) {
        //   this.errorMessage.push("Account Name can't be blank");
        // }

        // Check if Email is blank
        if (!this.model.email.trim()) {
          this.errorMessage.push("Email can't be blank");
        }

        if (!this.model.new_password.trim() ||
          !this.model.new_password_confirmation.trim()) {
          this.errorMessage.push("Password can't be blank");
        }
        if (this.model.new_password != this.model.new_password_confirmation){
          this.errorMessage.push("Password do not match");
        }
        // Check if Temporary Code is blank
        // if (!this.model.temporary_code.trim()) {
        //   this.errorMessage.push("Temporary Code can't be blank");
        // }

        // Check if Password is blank
        // Check if New password is not equal to New password confirmation
        if(this.userPasswordFormatStrict == true){
            if (this.passwordformatValidation.passwordReqOneUppercase) this.errorMessage.push(ValidateField.upperCaseCharacterRequired('Password', this.model.new_password_confirmation));
            if (this.passwordformatValidation.passwordReqOneLowercase) this.errorMessage.push(ValidateField.lowerCaseCharacterRequired('Password', this.model.new_password_confirmation));
            if (this.passwordformatValidation.passwordReqOneNumber) this.errorMessage.push(ValidateField.numericRequired('Password', this.model.new_password_confirmation));
            if (this.passwordformatValidation.passwordReqOneSpecialChar) this.errorMessage.push(ValidateField.specialCharacterRequired('Password', this.model.new_password_confirmation));
            this.errorMessage.push(ValidateField.charMinAndMax('Password', this.model.new_password_confirmation, this.passwordformatValidation.minPasswordLength, 128));
        }
        this.errorMessage = this._.compact(this.errorMessage);
        return this.errorMessage.length;
      },
      async passwordChange(){
        if(!this.validation()){
          const { acct, tp } = this.$route.query;

          let passwordResetPayload = {
            account_name: acct.trim(), // this.model.account_name.trim(),
            email: this.model.email,
            temporary_code: tp.trim(), // this.model.temporary_code,
            new_password: this.model.new_password
          }

          var post_request = await HTTPRequest.postRequest(this.endPoint + 'users/password_change', null, passwordResetPayload)
          // eslint-disable-next-line
          if(post_request == undefined){
            this.errorMessage.push("The temporary code is invalid. Click on 'Forgot Password' for a new code.");
          } else if (post_request.error) {
            this.errorMessage.push(post_request.error)
          } else {
            // alert(post_request['success'])
            this.successMessage = post_request['success']
            var bodyFormData = new FormData();
            bodyFormData.set('email', this.model.email);
            bodyFormData.append('password', this.model.new_password);
            bodyFormData.append('grant_type', 'password');
            axios({
              method: 'post',
              url:  this.endPoint.split("/api")[0] + '/oauth/token',
              headers: { "Access-Control-Allow-Origin": "*" },
              data: bodyFormData,
            })
            .then(function (response) {
              var data = response.data
              secureStorage.setItem("accessToken", data["access_token"]);
              secureStorage.setItem("refreshToken", data["refresh_token"]);
              secureStorage.setItem("email", component_x.model.email);
              secureStorage.setItem("loggedIn", true)
              component_x.updateUserEmail(component_x.model.email)
              component_x.updateLoggedInStatus(true)
              navigate.push('dashboard');
            })
            .catch(function (error) {
              //handle error
              // eslint-disable-next-line
              this.errorMessage.push("Error logging in.")
              //  alert("Invalid Credentials")
            });
          }
          this.model = {
            account_name: '',
            email: '',
            temporary_code: '',
            new_password: '',
            new_password_confirmation: ''
          }
        }
      },
      async getAccountSettings(){
        const { acct, tp } = this.$route.query;
        var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/account_settings?account_name='+ acct.trim() +'&field_name=code' , null, false)
        try {
          var AccountSettings = JSON.parse(credentials.value)
          if(AccountSettings.userPasswordFormatStrict != undefined){
                this.userPasswordFormatStrict = AccountSettings.userPasswordFormatStrict
              }
              if (this.userPasswordFormatStrict){
                if(AccountSettings.minPasswordLength!=undefined){
                    this.passwordformatValidation.minPasswordLength = AccountSettings.minPasswordLength
                } else {
                    this.passwordformatValidation.minPasswordLength = 6
                }
                if(AccountSettings.passwordReqOneUppercase!=undefined){
                    this.passwordformatValidation.passwordReqOneUppercase = AccountSettings.passwordReqOneUppercase
                }
                if(AccountSettings.passwordReqOneLowercase!=undefined){
                    this.passwordformatValidation.passwordReqOneLowercase = AccountSettings.passwordReqOneLowercase
                }
                if(AccountSettings.passwordReqOneNumber!=undefined){
                    this.passwordformatValidation.passwordReqOneNumber = AccountSettings.passwordReqOneNumber
                }
                if(AccountSettings.passwordReqOneSpecialChar!=undefined){
                    this.passwordformatValidation.passwordReqOneSpecialChar = AccountSettings.passwordReqOneSpecialChar
                }
                if(AccountSettings.onPasswordExpiration!=undefined){
                    this.onPasswordExpiration = AccountSettings.onPasswordExpiration
                    if(AccountSettings.passExpDuration!=undefined){
                        this.passwordformatValidation.passExpDuration = AccountSettings.passExpDuration
                    }
                }
              }
        } catch (error) {}
      }
    }
  }
</script>
<style>
</style>
